import agGridTheme from '../../../config/agGrid/theme'

// One compact grid sizing for every table in this feature (matrix + wizard steps).
export const MAPPING_GRID_ROW_HEIGHT = 32
export const MAPPING_GRID_HEADER_HEIGHT = 36

export const mappingGridTheme = agGridTheme.withParams({
  rowHeight: MAPPING_GRID_ROW_HEIGHT,
  headerHeight: MAPPING_GRID_HEADER_HEIGHT
})
